import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Resource} from '../../../graphql/resources.datatypes';

interface AvailableHotelsData {
    availableHotels: Resource[],
}

export const GET_AVAILABLE_HOTELS_QUERY = gql`
  query availableHotelsModal($id: Int!){
    availableHotels(id: $id) {
        id
        internal_name
        
        roomResources {
            id
            internal_name
            guest_capacity
            allow_manual_overbooking
            
            resource_banks {
                id
                remaining
                date
            }
        }
    }
  }
`;

export const availableHotels = (tourId?: number) => {
    const id = tourId ? tourId : -1;
    return useQuery<AvailableHotelsData>(
        GET_AVAILABLE_HOTELS_QUERY,
        {
            variables: {
                id
            }
        }
    );
};

export default availableHotels;